import { FESTIVAL_QUERY_ROOT } from "@/pages/tina/festivals/hooks/use-festival-repository";

/** The cache key of one festival page read (the one page), under the same root, so a write's invalidation reloads it. */
export const festivalPageKey = (id: string) =>
  [FESTIVAL_QUERY_ROOT, "page", id] as const;
